import React from 'react';
import { __ } from '../../Lang.js';

const GuestFeatures = () => {
  return (
    <section className="section section--its-all-here">
      <div className="its-all-here__container">
        <div className="its-all-here__text">
          <h2 className="its-all-here__title">{__('IT’S ALL HERE')}</h2>
<h3 className="its-all-here__title-subtitle its-all-here__title-subtitle--bold">
  {__('FROM MYSTICISM TO PRACTICAL SPIRITUALITY')}
</h3>          <p className="its-all-here__desc">
            {__('Your online source for the Teachings of the Spiritual Heart brought to you by John-Roger, John Morton, and the Movement of Spiritual Inner Awareness.')}
          </p>
          <div className="its-all-here__list-columns">
            <ul className="its-all-here__list">
              <li>{__('Seminars')}</li>
              <li>{__('Meditations')}</li>
              <li>{__('Live Event Recordings')}</li>
              <li>{__('Interviews')}</li>
              <li>{__('Audio Books')}</li>
            </ul>
            <ul className="its-all-here__list">
              <li>
                {__('Themes:')} <br />
                {__('Health')} <br />
                {__('Abundance/Wealth')} <br />
                {__('Forgiveness')} <br />
                {__('Relationships')} <br />
                {__('Soul Transcendence')}
              </li>
            </ul>
          </div>
        </div>
        <div className="its-all-here__image">
          <img
            src="https://now.cdn.msia.org/3259/TWI/twi_video_stack.png"
            alt={__('Video Devices')}
          />
        </div>
      </div>
    </section>
  );
};

export default GuestFeatures;